import { render, staticRenderFns } from "./EditorSidebar.vue?vue&type=template&id=bcf1b684&scoped=true&"
import script from "./EditorSidebar.vue?vue&type=script&lang=js&"
export * from "./EditorSidebar.vue?vue&type=script&lang=js&"
import style0 from "./EditorSidebar.vue?vue&type=style&index=0&id=bcf1b684&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf1b684",
  null
  
)

export default component.exports